
import {
  defineComponent, shallowRef, onMounted, ref, watch,
} from 'vue';
import generalStatus from './components/generalStatus.vue';
import greenArea from './components/greenArea.vue';
import monitList from './components/monitList.vue';
import timeMonit from './components/timeMonit.vue';
import caronNPP from './components/caronNPP.vue';
import caronMap from './components/caronMap.vue';

import store from '@/store';

export default defineComponent({
  components: {
    generalStatus,
    greenArea,
    monitList,
    timeMonit,
    caronMap,
    caronNPP,
  },
  setup () {
    onMounted(() => {
      // console.log('onMounted');
    });

    return {
    };
  },
});
